/* unplugin-vue-components disabled */import script from "./WOQuarterRank.vue?vue&type=script&setup=true&lang=js"
export * from "./WOQuarterRank.vue?vue&type=script&setup=true&lang=js"

import "./WOQuarterRank.vue?vue&type=style&index=0&id=6dfe4e63&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dfe4e63"]])

export default __exports__